export default __webpack_public_path__ + "static/media/chat.6044f4b2.svg";